import axiosInstance from 'api/axios.config';
import { ApiResponse } from 'types';

export interface ProviderBusiness {
  id: string;
  name: string;
  businessId?: string;
  active?: boolean;
  /** False when the business has withdrawn provider access. */
  providerAccessAllowed?: boolean;
}

/**
 * The businesses a service provider can work on behalf of.
 *
 * A provider's own SERVICE organisation is deliberately not in this list: it holds
 * no business_id, so selecting it makes every operational screen read zero.
 */
export const providerService = {
  businesses: async (): Promise<ApiResponse<ProviderBusiness[]>> => {
    try {
      const res = await axiosInstance.get('/v1/provider/businesses');
      return { success: res.data.success, data: res.data.data, message: res.data.message };
    } catch (e: any) {
      // A non-provider gets 403 here, which is not an error worth showing — the
      // switcher simply does not apply to them.
      return { success: false, error: e.response?.data?.message || 'Failed to load businesses' };
    }
  },
};
